interface SwatchProps {
  id: string | number;
  isActive: boolean;
  onClick: () => void;
  swatchImage: string;
}

const Swatch = ({ id, isActive, onClick, swatchImage }: SwatchProps) => {
  return (
    <button
      key={id}
      data-active={isActive}
      onClick={onClick}
      className={'swatch'}
    >
      <img src={swatchImage} alt="" />
    </button>
  );
};

export default Swatch;
